import { ApiService } from 'common/services';

class AuthApiService extends ApiService {
  getMe = () => {
    return this.get('/api/auth/me');
  };
}

export const authApi = new AuthApiService(process.env.REACT_APP_API_URL);
